<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'doctrine.disclaimer.content'|translate">
      <form class="" #disclaimerForm="ngForm" action="javascript:">
        <quill-editor [modules]="modules" [required]="true" [name]="'content'" [(ngModel)]="disclaimer.content" ></quill-editor>
        <br>
        <div class="text-end">
          <button (click)="backToOverview()" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button type="button" class="btn btn-primary ripple light" [disabled]="!disclaimerForm.valid" (click)="saveDisclaimer()">
            {{'global.actions.save'|translate}}
          </button>
        </div>
      </form>
    </app-card>
  </div>
</div>
